// extracted by mini-css-extract-plugin
module.exports = {"no_data_container":"index-no_data_container__iFPlK","collapsed_icon":"index-collapsed_icon__2OrYu"};